import React, { useContext, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import useUser from '../../../../contexts/hooks/useUser'
import { ModalContext } from '../../../../contexts/ModalContext'
import { trpc } from '../../../../modules/trpc'
import ModalWrapper from '../../../../wrappers/modalWrapper/ModalWrapper'

interface ChangelogProps {}

const Changelog: React.FC<ChangelogProps> = () => {
	const { data: changelogs } = trpc.changelog.get.useQuery()

	const { t } = useTranslation('modals_changelog')

	const { user, setUser } = useUser()

	const { closeModal } = useContext(ModalContext)

	const currentVersion = useMemo(() => {
		if (!changelogs) return null

		const currentVersion = process.env.REACT_APP_VERSION
		const versions = changelogs.find(changelog => changelog.version === currentVersion)

		return versions
	}, [changelogs])

	useEffect(() => {
		const handlePopState = () => {
			closeModal()
		}
		window.addEventListener('popstate', handlePopState)
		return () => window.removeEventListener('popstate', handlePopState)
	}, [closeModal])
	useEffect(() => {
		if (!user || !user?.versionNumber || user.versionNumber === process.env.REACT_APP_VERSION)
			return

		setUser({
			versionNumber: process.env.REACT_APP_VERSION,
		})
	}, [setUser])

	const renderText = (text: string) => {
		return text.split('\n').map((line, index) => <p key={index}>{line}</p>)
	}

	return (
		<ModalWrapper>
			<div id='changelog-page' className='h-full'>
				<div className='changelog bg-brand-secondary-200-light dark:bg-brand-secondary-100-dark'>
					{currentVersion && (
						<>
							<div className='version text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
								{currentVersion.version}
							</div>
							<span className='text-text-dark dark:text-text-dark'>
								{user?.language === 'fi'
									? renderText(currentVersion.textFi)
									: renderText(currentVersion.textEn)}
							</span>
						</>
					)}
				</div>

				<div className='absolute bottom-0 left-0 right-0 m-6'>
					<Button onClick={() => closeModal()}>{t('button')}</Button>
				</div>
			</div>
		</ModalWrapper>
	)
}

export default Changelog
